import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Student } from '../student';

@Injectable({
  providedIn: 'root'
})
export class StudentService {

  private readonly baseUrl = `${environment.apiUrl}/students`;

  constructor(private http: HttpClient) { }

  getAll(): Observable<Student[]> {
    return this.http.get<Student[]>(this.baseUrl);
  }

  getById(id: number): Observable<Student> {
    return this.http.get<Student>(`${this.baseUrl}/${id}`);
  }

  create(student: Student): Observable<Student> {
    return this.http.post<Student>(this.baseUrl, student);
  }

  update(id: number, student: Student): Observable<Student> {
    return this.http.put<Student>(`${this.baseUrl}/${id}`, student);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`);
  }

  /**
   * Call when the backend exposes “grant login” for a student (Option B).
   * Adjust the path to match your API (e.g. admin-only POST).
   */
  provisionLogin(studentId: number, body: Record<string, unknown> = {}): Observable<unknown> {
    return this.http.post(`${this.baseUrl}/${studentId}/provision-login`, body);
  }
}
